// eslint-disable-next-line
import React from 'react';
import { Page, Document, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { Paper } from '@mui/material';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PDFRender: React.FC<React.PropsWithChildren<{ file: string; pageCount: number; width: number }>> = (props) => {
    const [actualPageCount, setActualPageCount] = React.useState<number | null>(null);
    const resolvedPageCount = actualPageCount ? Math.min(actualPageCount, props.pageCount) : 0;

    return <div>
        <Document
            externalLinkTarget="_blank"
            file={props.file}
            onLoadSuccess={({ numPages }): void => setActualPageCount(numPages)}
        >
            {Array.from({ length: resolvedPageCount }, (_, i) => i + 1).map((page) => (
                <Paper key={page} variant="elevation" style={{ marginBottom: 20 }} elevation={3}>
                    <Page width={props.width} pageNumber={page} />
                </Paper>
            ))}
        </Document>
    </div>
}
